export const isUserLoggedIn = async () => {
  try {
    await window.Amplify.default.Auth.currentAuthenticatedUser();

    return true;
  } catch (e) {
    return false;
  }
};
